t = require('views/internal/teacup-with-helpers')('member_on_board_menu')

module.exports = ->
  t.li ->
    if t.mustacheVar 'canInviteMemberToTeam'
      t.a { class: 'js-add-to-team', href: '#' }, ->
        t.format 'add-to-team'
    t.mustacheBlock 'type', ->
      t.a { class: t.mustacheBlock('canChangeRole', (-> 'js-change-role')) + t.mustacheBlockInverted('canChangeRole', (-> 'disabled')), href: '#' }, ->
        t.format 'change-permissions-ellipsis-type', { type: t.mustacheVar('type') }
    t.mustacheBlockInverted 'type', ->
      t.a { class: t.mustacheBlock('canChangeRole', (-> 'js-change-role')) + t.mustacheBlockInverted('canChangeRole', (-> 'disabled')), href: '#' }, ->
        t.format 'change-permissions-ellipsis'

  t.li ->
    t.a { href: t.mustacheVar('boardProfileUrl') }, ->
      t.format 'view-member-s-board-activity'

  t.mustacheBlock 'canRemove', ->
    t.li ->
      t.a '.js-remove-member', ->
        t.mustacheBlock 'isMe', ->
          t.format 'leave-board-ellipsis'
        t.mustacheBlockInverted 'isMe', ->
          t.format 'remove-from-board-ellipsis'

  t.mustacheBlockInverted 'canRemove', ->
    t.mustacheBlock 'isMe', ->
      t.mustacheBlock 'isMoreThanOneMember', ->
        t.mustacheBlock 'memberIsAdmin', ->
          t.li ->
            t.hr()
            t.p '.quiet.u-bottom', ->
              t.format 'you-can-t-leave-because-you-are-the-only-admin-to-make-another-user-an-admin-click-their-avatar-select-change-permissions-ellipsis-and-select-admin'

  t.mustacheBlock 'isGhost', ->
    t.li ->
      t.hr()
      t.p '.quiet.u-bottom', ->
        t.format 'this-user-will-be-able-to-access-this-board-once-they-sign-up-with-trello-and-confirm-their-email-address'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/member_on_board_menu.coffee